import React, {Component} from "react";
import {ff, form, Loader} from "@mc/mc-legacy";
import {Button, Label} from "reactstrap";
import {FormErrors, reduxForm} from "redux-form";

type FormData = { ico: string };

const validate = (data: FormData) => {
    const errors: FormErrors<FormData> = {};

    if (!data.ico) {
        errors.ico = "IČO je povinné";
    }

    return errors;
};

class IcoInput extends Component<any> {

    constructor(props) {
        super(props);
    }

    render() {
        const {onClose, handleSubmit, submitting} = this.props;
        return (
            <div>
                <form.Form className={"form"} horiznotal onSubmit={handleSubmit}>
                    <form.FormBody>
                        <Label for={"ico"}>IČO</Label>
                        <ff.String
                            autoComplete={"off"}
                            label={false}
                            name={"ico"}
                            disabled={submitting}
                            required />
                    </form.FormBody>
                    <form.FormActions onClose={onClose} disabled={submitting} submitButton={false}>
                        <Button
                            className={"ml-2"}
                            color={"primary"}
                            type={"submit"}
                            disabled={submitting}
                        >
                            Vytvořit
                        </Button>
                    </form.FormActions>
                </form.Form>
            </div>
        );
    }
}
const IcoInputForm = reduxForm<FormData, any>({
    form: "icoInput",
    validate: validate,
})(IcoInput);
export default IcoInputForm;
